// formats used by moment library

export const DATE_FORMAT = 'DD/MM/YYYY';
export const DATE_FORMAT_WITH_TIME = 'DD/MM/YYYY HH:mm';
export const DATE_FORMAT_FOR_FILE = 'DDMMYYYY';
export const TIME_FORMAT = 'HH:mm';
export const UNIX_TIMESTAMP_FORMAT = 'X';
